/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { Organization } from '../../models/organization';

export interface GetOrganization$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
}

export function getOrganization(http: HttpClient, rootUrl: string, params: GetOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<Organization>> {
  const rb = new RequestBuilder(rootUrl, getOrganization.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Organization>;
    })
  );
}

getOrganization.PATH = '/organizations/{organizationKey}';
